/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  workbench.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:34
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { axiosAPIUrl, Parameter } from "./index";
import { GoodsListDto } from "@/api/commodity";
import { CustomerListDto } from "@/api/customerManage";

//待处理订单
export class PendingOrderDto {
  /* 关联编号 */
  relationId: string;
  /* 订单状态 */
  orderStatus: string;
  /* 订单状态名称 1.为退货类型  2.为订货类型 */
  orderStatusName: string;
  /* 是否为退订单 */
  isReturn: string;
  /* 数量 */
  count: string;
}



//折线图
export class HomeLineChartOrderDto {
  /* 某一天总金额 */
  totalMoney: string;
  /* 某一天总单数 */
  totalNumber: string;
  /* 日期 */
  date: string;
  /* 当前日期  true：当前日期   false：上期*/
  isCurrent: boolean;
  /* 类型  1、今天 2、本周 3、本月 */
  dateType: string;
}

//定期金额统计
export class OrderAmountByDateDto {
  //当isCurrent为true时 totalMoney就是本期的金额、totalNumber就是本期的数量
  //当isCurrent为false时 totalMoney就是本期与上期的金额差、totalNumber就是本期与上期的数量差
  /* 总金额 */
  totalMoney: string;
  /* 总数量 */
  totalNumber
  /* 当前日期  true：当前日期   false：上期*/
  isCurrent: boolean;
  /* 类型  1、今天 2、本周 3、本月 */
  dateType: string;

}

//通知公告
export class NoticeMessageInfoDto {
  /* 通知公告编号 */
  noticeId: string;
  /* 通知公告标题 */
  noticeTitle: string;
  /* 发布公告时间 */
  publishTime: string;
  /* 公司编号 */
  companyId: string;
  /* 公司名称 */
  companyName: string;
}

/**
 * 待处理订单
 * @param parameter
 */
export function getPendingOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/jccykjorder/IS/getPendingOrder",
    method: "post",
    data: parameter,
  });
}

/**
 * 折线图数据统计
 * @param parameter
 */
export function getHomeLineChartOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/jccykjorder/IS/getHomeLineChartOrder",
    method: "post",
    data: parameter,
  });
}
/**
 * 折线图数据统计
 * @param parameter
 */
export function getMoneyChartOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<HomeLineChartOrderDto>>({
    url: "/jccykjorder/IS/getHomeLineChartOrder",
    method: "post",
    data: parameter,
  });
}

/**
 * 定期金额金额统计
 * @param parameter
 */
export function getOrderAmountByDate (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/jccykjorder/IS/getOrderAmountByDate",
    method: "post",
    data: parameter,
  });
}

/**
 * 通知公告
 * @param parameter
 */
export function getNoticeMessageInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<NoticeMessageInfoDto>>({
    url: "/jccykjorder/IS/getNoticeMessageInfo",
    method: "post",
    data: parameter,
  });
}

export class MessageDetailDto {
  attachmentUrl?: string;
  contentRtf?: string;
  noticeTitle?: string;
  companyName?: string;
  publishTime?: string;
}

/**
 * 通知公告详情
 * @param parameter
 */
export function getCompanyNoticeInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<MessageDetailDto>>({
    url: "/jccykjmessage/CN/getCompanyNoticeInfo",
    method: "GET",
    params: parameter,
  });
}

/**
 * 阅读消息
 * @param parameter
 */
export function readMessage (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/jccykjmessage/messageCenter/readMessage",
    method: "GET",
    params: parameter,
  });
}

/**
 * 1.4 MN004-获取首页公告内容
 * @param parameter
 */
export function getPartnerCompanyNoticeInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/jccykjmessage/CN/getPartnerCompanyNoticeInfo",
    method: "GET",
    params: parameter,
    extraParams: { showLoading: false }
  });
}
